import { render, staticRenderFns } from "./input-4-property-id-mapper.vue?vue&type=template&id=19bbf77e&scoped=true&"
import script from "./input-4-property-id-mapper.vue?vue&type=script&lang=ts&"
export * from "./input-4-property-id-mapper.vue?vue&type=script&lang=ts&"
import style0 from "./input-4-property-id-mapper.vue?vue&type=style&index=0&id=19bbf77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbf77e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
